export default {
  en: {
    alarm: {
      PLAY_NOW: `Play Now`,
      SET_TIME: `Set Time`,
      SET_ALARM: `Set Alarm`,
      SAVE: `Save`,
      BY: `by`,
      TIME_WARNING: `Please set an alarm at least 20 minutes before`,
    },
    auth: {
      PLEASE_CONNECT_TO_INTERNET: `Please connect to the Internet`,
      LEGAL_TERMS_UNCHECKED: `Please accept the conditions of sale and our data policy to complete your registration`,
      INVITE_TERMS_UNCHECKED: `Please indicate that you have received your patient's consent`,
      INVITE_OR_USER_EMAIL_ALREADY_EXISTS: `An account associated with this email already exists`,
      ACCOUNTS_UPDATED_FOR_SOCIAL_SIGN_IN: `Account updated for sign in via Google successfully. Please sign in with Google again.`,
      AN_ERROR_OCCURED_PLEASE_TRY_LATER: `An error occurred, please try again later.`,
      SIGN_IN_WITH_GOOGLE: `Sign In with Google`,
      INTERNAL_SERVER_ERROR: `An error occured`,
      USER_WITH_THIS_EMAIL_ALREADY_EXISTS: `A user associated with this email alrady exists`,
      INVALID_REFERRAL_CODE: `Invalid referral code`,
      INVALID_INPUT: `An error occurred`,
      ACCESS_TOKEN_HAS_BEEN_REVOKED:
        'An unexpected error occured, please wait before logging in again',
      PLEASE_CHECK_YOUR_EMAIL: `Please check your email`,
      INVITE_NOT_FOUND: `Invite not found`,
      AUTHENTICATION_ERROR: `Invalid email or password`,
      A_RESET_CODE_IS_REQUIRED: `A reset code is is required`,
      ALREADY_HAVE_CODE: `Already have a code?`,
      ERROR: `An error occured`,
      ATTEMPT_LIMIT_EXCEEDED_PLEASE_TRY_AFTER_SOME_TIME:
        'Too many attempts, try again later',
      INVALID_VERIFICATION_CODE_PROVIDED_PLEASE_TRY_AGAIN: 'Invalid verification code',
      CODE: 'Verification code',
      ENTER_CODE_AND_NEW_PASSWORD:
        'Enter the code sent your email and set a new password',
      ENTER_EMAIL_TO_RESET: `Enter your email to reset your password`,
      RESET_PASSWORD: `Reset password`,
      GO_BACK: `Go back`,
      NETWORK_ERROR: `A network error occured`,
      CONNECTION_ERROR: `Cannot connect`,
      EMAIL: `Email`,
      INCORRECT_USERNAME_OR_PASSWORD: `Invalid email or password`,
      IN_CASE_YOU_FORGOT: `Forgot password?`,
      INVALID_EMAIL_OR_PASSWORD: `Invalid email or password`,
      LOG_IN: `Log in`,
      LOG_IN_TO_YOUR_ACCOUNT: `Sign in`,
      NOTAUTHORIZEDEXCEPTION: `Unknown error occured`,
      RESET_MY_PASSWORD: `Reset my password`,
      SIGN_UP: `Sign up`,
      PASSWORD: `Password`,
      PLEASE_FILL_ALL_FIELDS: `Please fill in all fields`,
      INVALID_EMAIL: `Invalid email`,
      EMAIL_IS_REQUIRED: `Email is required`,
      PRESCRIBER_CODE_IS_REQUIRED: `A partner code is required`,
      NEW_PASSWORD_IS_TOO_SHORT: '',
      NEW_PASSWORD_IS_TOO_LONG: '',
      NEW_PASSWORD_IS_REQUIRED: '',
      CONFIRM_PASSWORD_IS_REQUIRED: '',
      PASSWORD_IS_TOO_SHORT: `Password is too short`,
      PASSWORD_IS_TOO_LONG: `Password is too long`,
      PASSWORD_IS_REQUIRED: `Password is required`,
      PASSWORDS_DO_NOT_MATCH: `Passwords do not match`,
      PASSWORD_MUST_CONTAIN: `Password must contain at least one number, one uppercase, and one lowercase`,
      PASSWORD_CONFIRM: `Confirm password`,
      PLEASE_REGISTER_BEFORE_SOCIAL_SIGN_IN:
        'Please register your account first before attempting to sign in with a Google account',
      PLEASE_SET_A_PRIVATE_PASSWORD_BEFORE_SOCIAL_SIGN_IN:
        'Please set a private password for your account before attempting to sign in with a Google account',
      PRESCRIBER_CODE_MUST_CONTAIN: `A partner code is eight letters long`,
      PREAUTHENTICATION_FAILED_WITH_ERROR_NO_PLAYER_ACCESS: `This license does not allow player app access`,
      PREAUTHENTICATION_FAILED_WITH_ERROR_NUMBER_OF_DEVICES_EXCEEDED: `Max number of devices allowed by license reached`,
      SET_PASSWORD: `Set password`,
      SET_YOUR_PASSWORD: `Set your password`,
      TOGGLE_PASSWORD_VISIBILITY: `Toggle password visibility`,
      USER_DOES_NOT_EXIST: `User does not exist`,
      PAYMENT_ERROR: `We can't collect money for your last invoice. Please add valid payment method`,
      SUBSCRIPTION_WRONG_STATUS: 'Wrong subscription status',
      INVALID_PAYMENT_METHOD:
        'Invalid payment method. Please use valid payment method. If you still have problems with update card details, please contact with Sound Care support',
      PAYMENT_INTENT_AUTHENTICATION_FAILURE: `We are unable to authenticate your payment method. Please choose a different payment method and try again.`,
      UPDATE: `Update`,
      QUESTION_IS_REQUIRED: `Answer is required`,
      QUESTION_IS_TOO_SHORT: `Answer is too short`,
      QUESTION_IS_TOO_LONG: `Answer is too long`,
      WRONG_LOGOUT_CODE: `Wrong code`,
      LOGOUT_CODE_IS_REQUIRED: `Code is required`,
      LOGOUT_SUCCESSFUL: `Successful logout`,
      ENTER_CODE: `Enter code`,
      LOGOUT_SEND: `Check`,
      LOGOUT_HEADER: `Disconnect`,
      LOGOUT_DESCR: ``,
    },
    contactForm: {
      COMMERCIAL_INFO_1: `I wish to receive commercial offers from Sound Care. My data will be used in accordance with its `,
      COMMERCIAL_INFO_2: ` for three (3) years following my last contact with Sound Care or until I object to this use by clicking on the following link "I no longer wish to receive commercial offers ”appearing in our mailings or on simple written request to the DPO at the aforementioned contact details.`,
      CONTACT_LINK: `Data Protection Policy`,
      CONTACT_US: `Contact us`,
      EMAIL: `Account email`,
      EMAIL_PRO: 'Professional e-mail',
      FIRST_NAME: `First name`,
      FIRST_NAME_IS_REQUIRED: `First name is required`,
      FIRST_NAME_IS_TOO_LONG: `The first name is too long`,
      LEGAL_INFO: `Your personal data collected here is used in accordance with the Sound Care Data Protection Policy for the purposes of responding to the message you formulate on this page, then erased. For any questions relating to your personal data, you can contact its data protection officer (hereinafter “DPO”) at the postal address Sound Care - DPO 7 rue Popincourt - 75011 Paris (France) or by email: dpo@music.care`,
      EMAIL_INVALID: `Invalid email`,
      EMAIL_IS_REQUIRED: `Email is required`,
      LAST_NAME: `Last name`,
      LAST_NAME_IS_TOO_LONG: `Last name is too long`,
      LAST_NAME_IS_REQUIRED: `Last name is required`,
      MESSAGE: `Message`,
      CUSTOMER_SERVICE: `Product discovery`,
      TECHNICAL_SUPPORT: `Customer service`,
      SELECT_TYPE: `Type of request`,
      MESSAGE_IS_REQUIRED: `A message is required`,
      MESSAGE_IS_TOO_LONG: `The message is too long`,
      NEWSLETTERS_INFO_1: `I wish to receive newsletters from Sound Care. My data will be used in accordance with its `,
      NEWSLETTERS_INFO_2: ` for three (3) years following my last contact with Sound Care or until I object to this use by clicking on the following link "I no longer wish to receive of newsletters ”appearing in our mailings or on simple written request to the DPO at the aforementioned contact details.`,
      SEND_MESSAGE: `Send`,
      SEND_SUCCESS: `Message sent successfully`,
      SUPPORT_INFO: `The Sound Care team is here to help you and answer all of your questions. Please complete the form below and a representative will get back to you within 24 hours.`,
      TELEPHONE: `Professional phone`,
      TELEPHONE_IS_TOO_LONG: `The phone number is too long`,
      TELEPHONE_IS_REQUIRED: `Phone number is required`,
      FIRM: `Name of Health Establishment / Company / Employer`,
      FIRM_IS_REQUIRED: 'Firm name is required',
      PROJECT: `Project`,
      UNABLE_TO_SEND_MESSAGE: `Error: unable to send message`,
    },
    general: {
      YOUR_COMPANY_LOGO: `Your company logo`,
    },
    genre: {
      ALL: `All Sessions`,
      NO_SESSIONS_OFFLINE: `No sessions are downloaded for offline mode`,
      NO_SESSIONS: `No sessions are available`,
      ERROR: `An error occured. Please try again`,
      CHOOSE_SESSION: `Music Genres`,
      DISCOVER_TREATMENTS: `Please choose your session`,
      GENRES: `Music Genres`,
      NEW: `NEW`,
    },
    history: {
      AFTER: `After`,
      ANXIETY: `Anxiety`,
      AWAKENING: `Awakening`,
      BEFORE: `Before`,
      PAIN: `Wellness`,
      SLEEP: `Sleep`,
      SLEEPING: `Sleep`,
      LISTENING_HISTORY_EMPTY: `Your listening history is empty`,
      LISTENING_HISTORY: `Listening history`,
    },
    links: {
      ABOUT_MUSIC_CARE: `https://www.sound.care/en/company.html`,
      APP_APPLE_STORE: `https://apps.apple.com/ca/app/music-care/id849636644`,
      APP_GOOGLE_STORE: `https://play.google.com/store/apps/details?id=com.o12s.musiccare`,
      PRIVACY: `https://www.sound.care/en/personal-data.html`,
      TERMS_DOCTOR: `https://www.sound.care/conditions-pro.html`,
      TERMS_DOCTOR_2: `https://www.sound.care/politiques.html`,
      TERMS_DOCTOR_3: `https://docs.google.com/forms/d/e/1FAIpQLScAELoSaTvGcPgAj5_UbsMB49kZ_BmaJnEaQo8qgZ1kzp-9kQ/viewform`,
      TERMS_PATIENT: `https://www.sound.care/conditions.html`,
      TERMS_PRO: `https://www.sound.care/conditions-pro.html`,
      ACCOUNT: `https://app.music.care/contact`,
      VIEW_ACCOUNT: '/my-account',
      CHANGE_PASSWORD: '/my-account2',
      CHANGE_CARD: '/my-account3',
    },
    pain: {
      EMAIL_SUCCESSFULLY_SENT: `Email successfully sent`,
      SEND: `Send`,
      ENTER_EMAIL: `Enter email`,
      INVITE_PATIENT: `Recommend`,
      INVITE_PATIENT_DESCR_FREEDAYS_PRICE: `Please enter an email address below to receive access to Sound Care for a free {{ freeDays }}-day trial and {{ currency }}{{ price }}/mo afterwards.`,
      INVITE_PATIENT_DESCR_NOFREEDAYS_PRICE: `Please enter an email address below to receive access to Sound Care at a price of {{ currency }}{{ price }}/mo.`,
      INVITE_PATIENT_DESCR_NOPRICE: `Please enter an email address below to receive access to Sound Care for a free trial.`,
      PRESCRIBER_CODE: `Partner Code: {{ prescriberCode }}`,
      NO_ANXIETY: 'No anxiety',
      MAX_ANXIETY: 'Max anxiety',
      LEGAL_DISCLAIMER_1: `I certify that I have informed my patient and obtained his express consent, in accordance `,
      LEGAL_LINK: `with the applicable regulations on personal data`,
      LEGAL_DISCLAIMER_2: ` and the Sound Care T & Cs, to communicate the above email address to Sound Care so that the latter can offer him its services.`,
      NO_PAIN: 'No pain',
      MAX_PAIN: 'Max pain',
      CLICK_TO_PLACE_FINGER: `Click here to place your finger on the device's flash`,
      INDICATE_PAIN: `Indicate your level of pain`,
      INDICATE_ANXIETY: `Indicate your level of anxiety`,
      SCALE_SELECT_PAIN_AFTER: ``,
      SCALE_SELECT_PAIN_BEFORE: ``,
    },
    player: {
      ADD_IMMERSIVE: ``,
      APPROXIMATE_DURATION: `Listening time`,
      BY: `by`,
      DESCRIPTION: `Description`,
      COMMENTS: ``,
      INSTRUMENTS: `Instruments`,
      MINUTES: `minutes`,
      POSTED_ON: `Posted on`,
      VIDEO: `Video`,
    },
    protocol: {
      GET_INTO_COMFORTABLE_POSITION: `Please get into a comfortable position`,
    },
    settings: {
      BACK: `Back`,
      INVITE_PATIENT: `Invite a patient`,
      SETTINGS: `Settings`,
      ALARM: `Alarm`,
      DOWNLOADING_IN_BACKGROUND: `Downloading`,
      DOWNLOAD_BACKGROUND: `Download in background`,
      MY_PLAYLIST: `My playlist`,
      COULD_NOT_REMOVE_FILE: `Could not remove file file`,
      UNABLE_TO_DOWNLOAD_AT_THIS_TIME: `Unable to download, please try again`,
      NOT_CONNECTED_TO_THE_INTERNET: `You are not connected to the internet`,
      DOWNLOADING: `Downloading`,
      SELECT_ALL: `Select all`,
      DESELECT_ALL: `Deselect all`,
      START_DOWNLOAD: `Start download`,
      DOWNLOAD_MUSIC_DESC: `Click a song to download and play it directly from your device.`,
      YES: `Yes`,
      NO: `No`,
      CHANGE_CARD: 'Change payment method',
      CHANGE_PASSWORD: 'Change password',
      PAYMENT_HISTORY: `Payment history`,
      CHANGE_LANGUAGE: `Change Language`,
      YOUR_HISTORY: `Your History`,
      DOWNLOAD_MUSIC: `Download Music`,
      ABOUT_MUSIC_CARE: `About Sound Care`,
      TERMS: `Terms of Use`,
      PRIVACY: `Privacy Policy`,
      ACCOUNT: `Close Account`,
      VIEW_ACCOUNT: 'My Account',
      JOIN_DATE: 'Member Since: ',
      LOG_OUT: `Log out`,
      OLD_PASS: 'Old Password',
      NEW_PASS: 'New Password',
      SAVE_MUSIC_FILES_TO_DEVICE: `Save music files to device`,
      CANCEL_SUBSCRIPTION_TITLE: `Turn off recurring billing, subscription will expire after that period`,
      REACTIVATE_SUBSCRIPTION_TITLE: `Turn on recurring billing`,
      CANCEL_SUBSCRIPTION: `Cancel subscription`,
      REACTIVATE_SUBSCRIPTION: `Reactivate subscription`,
      // Do not translate the two language strings below:
      EN: `English`,
      FR: `Français`,
      UPDATE_INFO: `We are updating application...`,
      UPDATE_DEVICE: `Please don't turn off your device!`,
      TRAINING_VIDEO: `Training Video`,
    },
    signup: {
      ACCESS_TO_ALL_SESSIONS: `You now have access to all our sessions. We wish you a nice trip with our original music.`,
      ALREADY_MEMBER: `Already a member?`,
      AUTOMATIC_RENEWAL_DESCR: `The subscription automatically renews and is billed monthly. It is possible to cancel anytime with no fees. Available uniquely to new members.`,
      FREE_DAYS_AUTOMATIC_RENEWAL_DESCR: `After the free trial, the subscription automatically renews and is billed monthly. It is possible to cancel anytime with no fees. Available uniquely to new members.`,
      BEGINNING_ON: `Beginning on`,
      BEGINNING_TODAY: `Beginning today`,
      BROWSER_PLAY: `Or use your browser`,
      CANCEL_ANYTIME_1: `Cancel anytime. You will not be billed before`,
      CANCEL_ANYTIME_2: `. Receive a call two days before the end of your trial period.`,
      CANCEL_ANYTIME_3: `Cancel anytime.`,
      CONNECT: `Connect`,
      CONTINUE: `Continue`,
      CREDIT_CARD_NUMBER: `Numéro de Carte de Crédit`,
      CVV: `CVV`,
      DOWNLOAD_ON_IOS: `Download for iOS`,
      DOWNLOAD_ON_ANDROID: `Download for Android`,
      EMAIL: `Email`,
      EXPIRY: `Exp (MM / YY)`,
      EXP_MONTH: 'Exp. Month',
      EXP_YEAR: 'Exp. Year',
      FACTURATION_DESCR_1: `Billing commences at the end of your free period. Beginning on `,
      FACTURATION_DESCR_2: `, an amount of {{ usd }}{{ price }}{{ eur }} will automatically be billed to you monthly up to the time you cancel.`,
      FACTURATION_DESCR_3: `An amount of {{ currency }}{{ price }} will automatically be billed to you monthly up to the time you cancel.`,
      FAST_RELIEF: `Wellness and anxiety`,
      FIRST_DAYS_FREE: `first days free`,
      FREE_TRIAL_DAYS: `Free trial of {{ days }} days`,
      INFO_ACCESS_TO_SESSION: `Access to more than 50 sessions`,
      INFO_APPLICATION_WEB_MOBILE_TABLET: `Web, mobile, and tablet application`,
      INFO_CLINICALLY_PROVED: `Clinically shown to be effective`,
      INFO_ORIGINAL_MUSIC: `Original music from renowned artists`,
      INFO_TREATMENT_PAIN_ANXIETY: `Wellness and anxiety treatment`,
      INFO_TREATMENT_SLEEP_AWAKENING: `Sleep mode with wake-up alarm`,
      LEGAL_CHECKBOX_1_LABEL_A: `I have read and expressly accept the `,
      LEGAL_CHECKBOX_1_LABEL_B: ` by Sound Care.`,
      LEGAL_CHECKBOX_1_LABEL_LINK: `General Conditions of Use of Services`,
      LEGAL_CHECKBOX_2_LABEL_A: `I consent to my Health Data being used by Sound Care in accordance with its `,
      LEGAL_CHECKBOX_2_LABEL_LINK: `Data Protection Policy`,
      LEGAL_CHECKBOX_2_LABEL_B: ` (Article B§4) for the duration of my Account and the following 2 years or until I object to this use by clicking HERE or upon simple written request to the DPO at the aforementioned contact details.`,
      LEGAL_CHECKBOX_LABEL_DESCR: `Your personal data collected here is used in accordance with the Sound Care Data Protection Policy for the purposes of fulfilling its pre-contractual and / or contractual obligations towards you in the context of the provision of Sound Care services linked to your Account. For any questions relating to your personal data, you can contact its data protection officer (hereinafter “DPO”) at the postal address Sound Care - DPO 7 rue Popincourt - 75011 Paris (France) or by email: dpo@music.care`,
      MONTHLY: 'Monthly',
      NAME_CARDHOLDER: `Cardholder name`,
      PASSWORD: `Password`,
      PASSWORD_CONFIRM: `Confirm password`,
      PAYMENT_INFO: `Payment Information`,
      PER_MONTH: `per month`,
      PRESCRIBER_CODE: `Partner code`,
      PLEASE_CHECK_YOUR_EMAIL: `Please check your email`,
      SIGN_UP: `Get Access`,
      SIGN_UP_DESCR: `Benefit from a free 30-day trial without credit card`,
      SIGNING_UP_NO_PRESCRIBER_CODE: `Referred by`,
      SIGNING_UP: `Referred by`,
      SIGNING_UP_DESCR: `Benefit from a free 30-day trial without credit card`,
      SIGNING_UP_DESCR_BENEFIT: `Please enter the field below:`,
      SIGNING_NO_PRESCRIBER_CODE: `Please enter your email address to receive your invitation to Sound Care:`,
      TRY_TODAY: `Try today`,
      WELCOME_TO_MUSIC_CARE: `Welcome to Sound Care`,
      SIGNUP_BUTTON_1: `I have a partner code`,
      SIGNUP_BUTTON_2: `A Health Establishment`,
      SIGNUP_BUTTON_3: `A General Practitioner`,
      SIGNUP_BUTTON_4: `Other Health Professionals`,
      OR: `OU`,
      OR: `OR`,
    },
    treatment: {
      ANXIETY: `Anxiety`,
      AWAKENING: `Awakening`,
      PLEASE_CHOOSE_A_TREATMENT: `Choose your objective`,
      PAIN: `Wellness`,
      SLEEPING: `Sleep`,
      TREATMENT_DESCR: `After you have selected your objective, a musical algorithm will be applied.`,
    },
    treatmentSlides: {
      slide1: {
        TITLE: 'Sleep better',
        SUBTITLE: 'Choose the L Sequence',
      },
      slide2: {
        TITLE: 'Wellness and Anxiety',
        SUBTITLE: 'Choose the U Sequence',
      },
      slide3: {
        TITLE: 'Wake up refreshed',
        SUBTITLE: 'Choose the J Sequence',
      },
    },
    indication: {
      ANXIETY: `Wellness and Anxiety`,
      AWAKENING: `Wake up refreshed`,
      PAIN: `Wellness and Anxiety`,
      SLEEP: `Sleep better`,
    },
    playlist: {
      YOU_DID_NOT_SELECT: `You did not select any songs yet`,
      MY_PLAYLIST_DESCR: `Create a custom playlist by selecting songs from the left tab.`,
      CREATE_MY_PLAYLIST: `Create my playlist`,
      MY_PLAYLIST: `My playlist`,
      PLAYING_LAST_PLAYLIST_SONG: `Currently playing last song in playlist`,
      NEXT_SONG: `Next song`,
      APPROXIMATELY_TIME_LEFT: `Approximately {{  timeLeft }} minutes left in playlist`,
    },
    video: {
      ANTARCTIC: `Antarctic`,
      BOTSWANA: `Botswana`,
      BRASIL: `Brasil`,
      CARAIBES: `Caribbean`,
      'DESERT-DU-MAROC': `Morocco desert`,
      INDONESIE: `Indonesia`,
      MALI: `Mali`,
      'MED-CELTIQUE': `Med Celtic`,
      MONGOLE: `Mongol`,
    },
    welcome: {
      DAYS_LEFT: `Days left`,
      PRESCRIBE_MUSIC_CARE: `Prescribe Sound Care`,
      PREVIEW_MUSIC: '30-second musical samples',
      MAKE_DEMONSTRATION: `Make a demonstration`,
      USE_PERSONAL: `Only for personal use`,
      NEW_SUBSCRIPTION: `Use Sound Care Pro`,
      WELCOME: `Welcome to Sound Care`,
      WELCOME_DOCTOR_TITLE: `Choose your objective`,
      WATCH_VIDEO: `Watch video`,
      REGISTER_FOR: `Use Sound Care Pro`,
      SKIP_VIDEO: `Skip video`,
      HOW_TO_USE: `How to use Sound Care?`,
      CHOOSE_ENVIRONMENT: `Choose a quiet environment and relax`,
      USE_EARPHONES: `Use earphones or speakers of good quality`,
      UNLIMITED_ACCESS: `Learn more`,
      LIE_DOWN: `Get into a comfortable position`,
    },
    subscription: {
      SUBSCRIBE: `Subscribe`,
      CONTINUE: `Continue`,
      PRICE: `34.95`,
      CURRENCY: `USD`,
      INFO_LINE_1: `Unlimited access to Sound Care treatments`,
      INFO_LINE_2: `Prescribe Sound Care to your patients`,
      INFO_LINE_3: `Access reports of wellness and anxiety levels (before and after Sound Care) for your patients`,
      INFO_LINE_4: `Access to professional training capsules`,
      INFO_LINE_5: `24 hour assistance`,
      INFO_LINE_6: `SACEM fee included`,
      INFO_LINE_7: `Three licenses included`,
      FAST_RELIEF: `Sound Care, care through music, allows you to:`,
      PER_MONTH: `per month`,
      MANAGE_ACCOUNT: `Looking to manage your account?`,
      MANAGE_SUBSCRIPTION: `Free trial or subscription has expired!`,
      MANAGE_PAYMENT: `Update your payment method!`,
      MANAGE_GO_TO: `Please go to Sound Care on the web to manage your account.`,
      AUTOMATIC_RENEWAL_DESCR: `After the free trial, the subscription automatically renews and is billed monthly. It is possible to cancel anytime with no fees. Available uniquely to new members.`,
      FACTURATION_DESCR: `An amount of {{ usd }}{{ price }}{{ eur }} will automatically be billed to you monthly up to the time you cancel.`,
      PAYMENT_INFO: `Payment Information`,
      CANCEL_ANYTIME: `Cancel anytime.`,
      BEGINNING_TODAY: `Beginning today`,
      EMAIL: `Email address`,
      INSCRIPTION: `Your trial has ended`,
      DESCRIPTION_1: `Help us improve Sound Care by answering the following questions:`,
      QUESTION_1: `Has Sound Care helped relieve your stress, and/or trouble sleeping?`,
      QUESTION_2: `Did you find Sound Care easy to use?`,
      QUESTION_3: `Would you recommend Sound Care?`,
    },
    registrationPage: {
      ACCOUNT_CREATED_SUCCESSFULLY: `Account registered successfully`,
      CONGRATULATIONS: `Congratulations! You have completed the training`,
      CONGRATULATIONS_SUBTITLE: `Please create your free account to recommend Sound Care to your patients through demonstrator access and your patient management tool.`,
      DOCTOR_ID: `RPPS or ADELI number`,
      DOCTOR_ID_CAN_BE_AT_MOST: `RPPS number can be at most {{ max }} characters`,
      DOCTOR_ID_IS_REQUIRED: `RPPS/ADELI number is required`,
      DOCTOR_REGISTRATION: `Doctor registration`,
      EMAIL: `Email`,
      LEGAL_DOCTOR_A: `I have read and expressly accept the `,
      LEGAL_DOCTOR_B: ` by Sound Care.`,
      LEGAL_DOCTOR_DESCR_A: `Your personal data collected here is used in accordance with the `,
      LEGAL_DOCTOR_DESCR_B: ` (Article B§3) of Sound Care for the purposes of meeting its pre-contractual and / or contractual obligations towards you in the context of the provision of Sound Care services linked to your Account. For any questions relating to your personal data, you can contact its data protection officer (hereinafter “DPO”) at the postal address Sound Care - DPO 7 rue Popincourt - 75011 Paris (France) or by email: dpo@music.care `,
      LEGAL_DOCTOR_DESCR_LINK: `Data Protection Policy`,
      LEGAL_DOCTOR_LINK: `General Conditions of Use of Services`,
      LEGAL_DOCTOR_C_1: `J’accepte que mes Données de Santé soient utilisées par Sound Care suivant sa Politique de `,
      LEGAL_DOCTOR_C_2: ` de façon totalement anonymisée pour des recherches scientifiques pour le développement des services thérapeutiques de Sound Care. Je peux m’opposer à cet usage à tout moment en cliquant `,
      LEGAL_DOCTOR_C_3: ` ou sur demande écrite aux coordonnées précitées.`,
      LEGAL_DOCTOR_LINK_2: `Protection des Données`,
      LEGAL_DOCTOR_LINK_3: `ICI`,
      NAME: `Name`,
      NAME_CAN_BE_AT_MOST: `Name can be at most {{ max }} characters`,
      NAME_IS_REQUIRED: `Name is required`,
      PASSWORD: `Password`,
      PASSWORD_CONFIRM: `Confirm password`,
      PASSWORD_CAN_BE_AT_MOST: `Password can be at most {{ max }} characters`,
      PASSWORDS_DO_NOT_MATCH: `Passwords do not match`,
      PASSWORD_IS_REQUIRED: `Password is required`,
      PASSWORD_IS_TOO_SHORT: `Password is too short`,
      PASSWORD_MUST_CONTAIN: `Password must contain at least one number, one uppercase, one lowercase, and one special case character`,
      REGISTER: `Register`,
      RPPS_INVALID: 'Your RPPS/ADELI number was invalid',
      TOGGLE_PASSWORD_VISIBILITY: `Toggle password visibility`,
      JOIN_TERMS_UNCHECKED: `Please accept the conditions of sale and our data policy to complete your registration`,
      INVALID_INVITE: `Invalid or expired invite`,
      INVALID_OR_EXPIRED_INVITE: `Invalid or expired invite`,
      PLEASE_COMPLETE_E_LEARNING_MODULE: `Please complete the e-learning module before registration`,
    },
    notification: {
      TITLE: `Sound Care`,
      DESCRIPTION: `Listening music...`,
      DESCRIPTION_UPDATE: `Updating the application...`,
    },
    license: {
      SCREEN_LIMIT: `Screen Limit`,
      DESCRIPTION_1: `Too many people are using your account right now.`,
      DESCRIPTION_2: `Please log out from on or more devices and try again.`,
      DESCRIPTION_3: `You may also logout from all your devices `,
      DESCRIPTION_LINK: `here.`,
      MORE_LICENSES: `Request more licenses`,
      MORE_LICENSES_EMAIL: `https://app.music.care/contact`,
      CONTACT: `Contact support`,
      CONTACT_EMAIL: `https://app.music.care/contact`,
      GO_BACK: `Go back`,
    },
    requestAccess: {
      MAIN_INSCRIPTION: `Welcome`,
      MAIN_DESCRIPTION: `The first digital therapy validated by more than 150 scientific publications in the treatment of pain, anxiety and sleep disorders.`,
      INSCRIPTION: `Welcome`,
      HEADER: `Request Sent`,
      DESCRIPTION_1: `In order to get access to Sound Care, please answer the following 3 questions?`,
      DESCRIPTION_2: `A member of the Sound Care team will contact you shortly.`,
      DESCRIPTION_3: `Please allow up to 48 hours for confirmation of your access.`,
      SIGNUP: `Get Access`,
      REQUEST_ACCESS: `Signup`,
      MEMBER: `Already a member? Login`,
      GO_BACK: `Back`,
      EMAIL: `Email address`,
      QUESTION_1: `Do you have pain?`,
      QUESTION_2: `Do you feel anxiety?`,
      QUESTION_3: `Do you have trouble sleeping?`,
      TRUE: `Yes`,
      FALSE: `No`,
    },
  },
  fr: {
    alarm: {
      PLAY_NOW: `Commencer`,
      SET_TIME: `Régler l'heure`,
      SET_ALARM: `Régler votre réveil`,
      SAVE: `Valider`,
      BY: `par`,
      TIME_WARNING: `Veuillez régler une alarme au moins 20 minutes avant l'heure du reveil`,
    },
    auth: {
      PLEASE_CONNECT_TO_INTERNET: `Veuillez vous connecter à Internet`,
      LEGAL_TERMS_UNCHECKED: `Veuillez accepter les condition de ventes et notre politique de donnes pour completer votre inscription`,
      INVITE_TERMS_UNCHECKED: `Veuillez indiquer que vous avez reçu le consentement de votre patient`,
      INVITE_OR_USER_EMAIL_ALREADY_EXISTS: `Un compte avec cette adresse e-mail existe déjà`,
      ACCOUNTS_UPDATED_FOR_SOCIAL_SIGN_IN: `Compte mis à jour pour la connexion via Google. Veuillez vous reconnecter avec Google une fois de plus.`,
      AN_ERROR_OCCURED_PLEASE_TRY_LATER: `Une erreur est survenue. Réessayez plus tard s'il vous plaît.`,
      SIGN_IN_WITH_GOOGLE: `Connectez-vous avec Google`,
      ACCESS_TOKEN_HAS_BEEN_REVOKED:
        "Une erreur inattendue s'est produite, veuillez patienter avant de vous reconnecter",
      INTERNAL_SERVER_ERROR: `Une erreur s'est produite`,
      USER_WITH_THIS_EMAIL_ALREADY_EXISTS: `A user associated with this email alrady exists`,
      INVALID_REFERRAL_CODE: `Le code partenaire est invalide`,
      INVALID_INPUT: `Une erreur s'est produite`,
      PLEASE_CHECK_YOUR_EMAIL: `Veuillez vérifier vos emails`,
      INVITE_NOT_FOUND: `Invite introuvable`,
      PRESCRIBER_CODE_MUST_CONTAIN: `Un code partenaire est composé de huit lettres`,
      ATTEMPT_LIMIT_EXCEEDED_PLEASE_TRY_AFTER_SOME_TIME:
        'Trop de tentatives, réessayez plus tard',
      PREAUTHENTICATION_FAILED_WITH_ERROR_NO_PLAYER_ACCESS: `Votre licence ne permet pas d'accéder à l'application du lecteur`,
      PREAUTHENTICATION_FAILED_WITH_ERROR_NUMBER_OF_DEVICES_EXCEEDED: `Limite de connexion de l'utilisateur de licence atteinte`,
      ERROR: `Veuillez vous identifier`,
      USER_DOES_NOT_EXIST: `L'utilisateur n'existe pas`,
      INVALID_VERIFICATION_CODE_PROVIDED_PLEASE_TRY_AGAIN:
        'Code de vérification non valide',
      CODE: 'Code de réinitialisation',
      ENTER_CODE_AND_NEW_PASSWORD:
        'Entrez le code envoyé à votre e-mail et définissez un nouveau mot de passe',
      A_RESET_CODE_IS_REQUIRED: `Un code de réinitialisation est requis`,
      ALREADY_HAVE_CODE: `Vous avez déjà un code ?`,
      ENTER_EMAIL_TO_RESET: `Entrez votre email pour réinitialiser votre mot de passe`,
      RESET_PASSWORD: `Réinitialiser le mot de passe`,
      GO_BACK: `Revenir en arrière`,
      NETWORK_ERROR: `Une erreur réseau s'est produite`,
      PASSWORD_MUST_CONTAIN: `Le mot de passe doit contenir au moins un chiffre, une majuscule, et une minusculee`,
      SET_PASSWORD: `Définir le mot de passe`,
      PASSWORD_CONFIRM: `Confirmer le mot de pass`,
      SET_YOUR_PASSWORD: `Définissez votre mot de passe`,
      AUTHENTICATION_ERROR: `Email ou mot de passe invalide`,
      INVALID_EMAIL_OR_PASSWORD: `E-mail ou mot de passe invalide`,
      PLEASE_FILL_ALL_FIELDS: `Veuillez remplir tous les champs`,
      EMAIL: `Email`,
      IN_CASE_YOU_FORGOT: `Mot de passe oublié ?`,
      LOG_IN: `S'identifier`,
      LOG_IN_TO_YOUR_ACCOUNT: `Votre compte`,
      RESET_MY_PASSWORD: `Réinitialiser mon mot de passe`,
      SIGN_UP: `Obtenir un accès`,
      PASSWORD: `Mot de passe`,
      INVALID_EMAIL: `Email invalide`,
      EMAIL_IS_REQUIRED: `L'email est requis`,
      PRESCRIBER_CODE_IS_REQUIRED: `Un code partenaire est requis`,
      NEW_PASSWORD_IS_TOO_SHORT: '',
      NEW_PASSWORD_IS_TOO_LONG: '',
      NEW_PASSWORD_IS_REQUIRED: '',
      CONFIRM_PASSWORD_IS_REQUIRED: '',
      PASSWORD_IS_TOO_SHORT: `Le mot de passe est trop court`,
      PASSWORD_IS_TOO_LONG: `Le mot de passe est trop long`,
      PASSWORD_IS_REQUIRED: `Mot de passe requis`,
      PLEASE_REGISTER_BEFORE_SOCIAL_SIGN_IN:
        'Veuillez vous enregistrer votre compte avant de tenter de vous connecter avec un compte Google',
      PLEASE_SET_A_PRIVATE_PASSWORD_BEFORE_SOCIAL_SIGN_IN:
        'Veuillez définir un mot de passe privé pour votre compte avant de tenter de vous connecter avec un compte Google',
      CONNECTION_ERROR: `Connexion refusée`,
      PASSWORDS_DO_NOT_MATCH: `Les mots de passe ne correspondent pas`,
      NOTAUTHORIZEDEXCEPTION: `Une erreur inconnue s'est produite`,
      TOGGLE_PASSWORD_VISIBILITY: `Basculer la visibilité du mot de passe`,
      INCORRECT_USERNAME_OR_PASSWORD: `E-mail ou mot de passe invalide`,
      PAYMENT_ERROR: `Votre dernier paiement n'a pas été accepté. Veuillez contacter votre banque où mettre à jour votre mode de paiement`,
      SUBSCRIPTION_WRONG_STATUS: `Statut d'abonnement erroné`,
      INVALID_PAYMENT_METHOD: `Mode de paiement invalide. Veuillez utiliser un mode de paiement valide. Si vous rencontrez toujours des problèmes avec la mise à jour des détails de la carte, veuillez contacter l'assistance Sound Care.`,
      PAYMENT_INTENT_AUTHENTICATION_FAILURE: `Nous ne sommes pas en mesure d'authentifier votre mode de paiement. Veuillez choisir un autre mode de paiement et réessayer.`,
      UPDATE: `Mettre à jour`,
      QUESTION_IS_REQUIRED: `Réponse requise`,
      QUESTION_IS_TOO_SHORT: `Réponse est trop courte`,
      QUESTION_IS_TOO_LONG: `Réponse est trop longue`,
      WRONG_LOGOUT_CODE: `Wrong code`,
      LOGOUT_CODE_IS_REQUIRED: `Code is required`,
      LOGOUT_SUCCESSFUL: `Successful logout`,
      ENTER_CODE: `Entrez le code`,
      LOGOUT_SEND: `Valider`,
      LOGOUT_HEADER: `Déconnexion`,
      LOGOUT_DESCR: ``,
    },
    contactForm: {
      COMMERCIAL_INFO_1: `Je souhaite recevoir les offres commerciales de Sound Care. Mes données seront utilisées conformément à sa `,
      COMMERCIAL_INFO_2: ` pendant trois (3) ans suivants mon dernier contact avec Sound Care ou jusqu’à ce que je m’oppose à cet usage en cliquant sur le lien suivant « je ne souhaite plus recevoir d’offres commerciales » figurant dans nos envois ou sur simple demande écrite au DPO aux coordonnées précitées.`,
      CONTACT_LINK: `Politique de Protection des Données`,
      CONTACT_US: `Contactez nous`,
      EMAIL: `E-Mail du compte`,
      EMAIL_PRO: 'E-Mail professionnel',
      FIRST_NAME: `Prénom`,
      FIRST_NAME_IS_REQUIRED: `Le prénom est requis`,
      FIRST_NAME_IS_TOO_LONG: `Le prénom est trop long`,
      LEGAL_INFO: `Vos données personnelles ici collectées sont utilisées conformément à la Politique de Protection des Données de Sound Care  aux fins de répondre au message que vous formulez sur cette page, puis effacées. Pour toute question relative à vos données personnelles, vous pouvez contacter son délégué à la protection des données (ci-après « DPO ») joignable à l’adresse postale Sound Care – DPO 7 rue Popincourt – 75011 Paris (France) ou par email : dpo@music.care`,
      EMAIL_INVALID: `Email invalide`,
      EMAIL_IS_REQUIRED: `L'email est requis`,
      LAST_NAME: `Nom`,
      LAST_NAME_IS_TOO_LONG: `Le nom de famille est trop long`,
      LAST_NAME_IS_REQUIRED: `Last name is required`,
      MESSAGE: `Message`,
      CUSTOMER_SERVICE: `Découverte produit`,
      TECHNICAL_SUPPORT: `Service client`,
      SELECT_TYPE: `Type de demande`,
      MESSAGE_IS_REQUIRED: `Un message est requis`,
      MESSAGE_IS_TOO_LONG: `Le message est trop long`,
      NEWSLETTERS_INFO_1: `Je souhaite recevoir des newsletters de Sound Care. Mes données seront utilisées conformément à sa `,
      NEWSLETTERS_INFO_2: ` pendant trois (3) ans suivants mon dernier contact avec Sound Care ou jusqu’à ce que je m’oppose à cet usage en cliquant sur le lien suivant « je ne souhaite plus recevoir de newsletters » figurant dans nos envois ou sur simple demande écrite au DPO aux coordonnées précitées.`,
      SEND_MESSAGE: `Envoyer`,
      SEND_SUCCESS: `Message envoyé avec succès`,
      SUPPORT_INFO: `L’équipe Sound Care est là pour vous aider et répondre à toutes vos questions. Veuillez remplir le formulaire ci-dessous et un représentant vous répondra en moins de 24 heures.`,
      TELEPHONE: `Téléphone professionnel`,
      TELEPHONE_IS_TOO_LONG: `Le téléphone est trop long`,
      TELEPHONE_IS_REQUIRED: `Telephone is required`,
      FIRM: `Nom de l'Etablissement de santé affilié/Société/Employeur`,
      FIRM_IS_REQUIRED: 'Firm name is required',
      PROJECT: `Projet`,
      UNABLE_TO_SEND_MESSAGE: `Erreur : impossible d'envoyer le message`,
    },
    general: {
      YOUR_COMPANY_LOGO: `Le logo de votre entreprise`,
    },
    genre: {
      ALL: `Toutes les séances`,
      ERROR: `Une erreur s'est produite: Veuillez réessayer`,
      NO_SESSIONS: `Aucune séance disponible maintenant`,
      NO_SESSIONS_OFFLINE: `Aucune séance actuellement disponible en mode hors ligne`,
      CHOOSE_SESSION: `Genre Musical`,
      DISCOVER_TREATMENTS: `Choisissez votre séance`,
      GENRES: `Genre Musical`,
      NEW: `NOUVEAUTÉ`,
    },
    history: {
      AFTER: `Après`,
      ANXIETY: `Stress`,
      AWAKENING: `Réveil`,
      BEFORE: `Avant`,
      PAIN: `Bien-être`,
      SLEEP: `Sommeil`,
      SLEEPING: `Sommeil`,
      LISTENING_HISTORY_EMPTY: `Votre historique d'écoute est vide`,
      LISTENING_HISTORY: `Historique d'écoute`,
    },
    links: {
      ABOUT_MUSIC_CARE: `https://www.sound.care/fr/Compagnie.html`,
      APP_APPLE_STORE: `https://apps.apple.com/ca/app/music-care/id849636644`,
      APP_GOOGLE_STORE: `https://play.google.com/store/apps/details?id=com.o12s.musiccare`,
      PRIVACY: `https://www.sound.care/politiques.html`,
      TERMS_DOCTOR: `https://www.sound.care/conditions-pro.html`,
      TERMS_PATIENT: `https://www.sound.care/conditions.html`,
      TERMS_PRO: `https://www.sound.care/conditions-pro.html`,
      TERMS_DOCTOR_2: `https://www.sound.care/politiques.html`,
      TERMS_DOCTOR_3: `https://docs.google.com/forms/d/e/1FAIpQLScAELoSaTvGcPgAj5_UbsMB49kZ_BmaJnEaQo8qgZ1kzp-9kQ/viewform`,
      ACCOUNT: `https://app.music.care/contact`,
      VIEW_ACCOUNT: '/my-account',
      CHANGE_PASSWORD: '/my-account2',
      CHANGE_CARD: '/my-account3',
    },
    pain: {
      EMAIL_SUCCESSFULLY_SENT: `Courriel envoyé avec succès`,
      SEND: `Envoyer`,
      ENTER_EMAIL: `Indiquer l’adresse email du patient`,
      INVITE_PATIENT: `Recommander`,
      INVITE_PATIENT_DESCR_FREEDAYS_PRICE: `Après son inscription, votre patient bénéficie d'un essai gratuit de 30 jours. Ensuite, l'abonnement est de 9,90€ par mois sans engagement de durée.`,
      INVITE_PATIENT_DESCR_NOFREEDAYS_PRICE: `Après son inscription, votre patient bénéficie d'un essai gratuit de 30 jours. Ensuite, l'abonnement est de {{ currency }}{{ price }} par mois sans engagement de durée.`,
      INVITE_PATIENT_DESCR_NOPRICE: `Après son inscription, votre patient bénéficie d'un essai gratuit de 30 jours. Ensuite, l'abonnement est de 9,90€ par mois sans engagement de durée.`,
      PRESCRIBER_CODE: `Code Partenaire: {{ prescriberCode }}`,
      LEGAL_DISCLAIMER_1: `Je certifie avoir informé mon patient et recueilli son consentement exprès, conformément à la réglementation applicable en matière de données personnelles et aux `,
      LEGAL_DISCLAIMER_2: ` de Sound Care pour communiquer l’adresse email ci-dessus à la société Sound Care afin que cette dernière lui propose ses services.`,
      LEGAL_LINK: `CGVU PRO`,
      NO_ANXIETY: 'Pas de stress',
      MAX_ANXIETY: 'Stress max',
      NO_PAIN: 'Pas de Bien-être',
      MAX_PAIN: 'Bien-être max',
      CLICK_TO_PLACE_FINGER: `Cliquez ici pour placer votre doigt sur le flash de l'appareil`,
      INDICATE_PAIN: `Indiquer votre niveau de Bien-être`,
      INDICATE_ANXIETY: `Indiquer votre niveau de stress`,
      SCALE_SELECT_PAIN_AFTER: ``,
      SCALE_SELECT_PAIN_BEFORE: ``,
    },
    player: {
      APPROXIMATE_DURATION: `Durée d’écoute`,
      BY: `par`,
      DESCRIPTION: `Description`,
      INSTRUMENTS: `Instruments`,
      MINUTES: `minutes`,
      POSTED_ON: `Posté le`,
      VIDEO: `Vidéo`,
    },
    protocol: {
      GET_INTO_COMFORTABLE_POSITION: `Veuillez vous mettre dans une position confortable`,
    },
    signup: {
      ACCESS_TO_ALL_SESSIONS: `Vous pouvez désormais accéder à l’application Sound Care à partir de votre ordinateur, smartphone ou tablette.`,
      ALREADY_MEMBER: `Déjà membre ?`,
      AUTOMATIC_RENEWAL_DESCR: `L'abonnement mensuel est facturé et se renouvellent automatiquement chaque mois. Il est possible d’annuler sans frais. Éligible uniquement pour les nouveaux utilisateurs.`,
      FREE_DAYS_AUTOMATIC_RENEWAL_DESCR: `Après l’essai gratuit, l’abonnement mensuel est facturé et renouvelé automatiquement chaque mois. Il est possible d’annuler sans frais. Eligible uniquement pour les nouveaux utilisateurs.`,
      BEGINNING_ON: `À partir du`,
      BEGINNING_TODAY: `À partir d'aujord'hui`,
      BROWSER_PLAY: `Accès webapp`,
      CANCEL_ANYTIME_1: `Vous pourrez vous désabonner à tout moment à partir de votre compte. Vous ne serez pas facturé avant le`,
      CANCEL_ANYTIME_2: `. Vous recevrez un rappel 2 jours avant la fin de votre essai gratuit`,
      CONNECT: `Connectez-vous`,
      CONTINUE: `Continuer`,
      CREDIT_CARD_NUMBER: `Numéro de Carte de Crédit`,
      CVV: `CVV`,
      DOWNLOAD_ON_IOS: `Télécharger sur iOS`,
      DOWNLOAD_ON_ANDROID: `Télécharger sur Android`,
      EMAIL: `Email`,
      EXPIRY: `Exp (MM / AA)`,
      EXP_MONTH: 'Exp. Mois',
      EXP_YEAR: 'Exp. Année',
      FACTURATION_DESCR_1: `La facturation commencera à la fin de votre essai gratuit. A partir du `,
      FACTURATION_DESCR_2: `, un montant de {{ currency }}{{ price }} vous sera automatiquement facturé chaque mois.`,
      FACTURATION_DESCR_3: `Un montant de {{ currency }}{{ price }} vous sera automatiquement facturé chaque mois jusqu’à ce que vous annuliez. Vous pourrez vous désabonner à tout moment à partir de votre espace personnel sur Sound Care.`,
      FAST_RELIEF: `Sound Care, le soin par la musique, vous permettra de:`,
      FIRST_DAYS_FREE: `premiers jours gratuits`,
      FREE_TRIAL_DAYS: `Essai gratuit de {{ days }} jours`,
      INFO_ACCESS_TO_SESSION: `Bien-être`,
      INFO_APPLICATION_WEB_MOBILE_TABLET: `Surmonter le stress`,
      INFO_CLINICALLY_PROVED: `Mieux dormir`,
      INFO_ORIGINAL_MUSIC: `Bien se réveiller`,
      LEGAL_CHECKBOX_1_LABEL_A: `J’ai lu et accepte expressément les `,
      LEGAL_CHECKBOX_1_LABEL_B: ` de Sound Care.`,
      LEGAL_CHECKBOX_1_LABEL_LINK: `Conditions Générales d’Utilisation des Services`,
      LEGAL_CHECKBOX_2_LABEL_A: `Je consens à ce que mes Données de Santé soient utilisées par Sound Care en conformité avec sa `,
      LEGAL_CHECKBOX_2_LABEL_LINK: `Politique de Protection des Données`,
      LEGAL_CHECKBOX_2_LABEL_B: ` pendant toute la durée de mon Compte et 2 ans suivants ou jusqu’à ce que je m’oppose à cet usage en cliquant ICI ou sur simple demande écrite au DPO aux coordonnées précitées.`,
      LEGAL_CHECKBOX_LABEL_DESCR: `Vos données personnelles ici collectées sont utilisées conformément à la Politique de Protection des Données (Article B§3) de Sound Care aux fins de répondre à ses obligations précontractuelles et/ou contractuelles à votre égard dans le cadre la fourniture des services de Sound Care liés à votre Compte. Pour toute question relative à vos données personnelles, vous pouvez contacter son délégué à la protection des données (ci-après « DPO ») joignable à l’adresse postale Sound Care – DPO 7 rue Popincourt – 75011 Paris (France) ou par email : dpo@music.care`,
      INFO_TREATMENT_PAIN_ANXIETY: `Mieux vivre avec sa Bien-être et le stress`,
      INFO_TREATMENT_SLEEP_AWAKENING: `Mieux dormir et Bien vous réveiller`,
      MONTHLY: 'Mensuel',
      NAME_CARDHOLDER: `Nom du titulaire`,
      PASSWORD: `Mot de passe`,
      PASSWORD_CONFIRM: `Confirmer le mot de passe`,
      PAYMENT_INFO: `Informations de Paiement`,
      PER_MONTH: `par mois`,
      PLEASE_CHECK_YOUR_EMAIL: `S'il vous plaît vérifier vos e-mails`,
      PRESCRIBER_CODE: `Code Partenaire`,
      SIGN_UP: `S’inscrire`,
      SIGN_UP_DESCR: `Bénéficier d'un essai gratuit de 30 jours sans CB`,
      SIGNING_UP_NO_PRESCRIBER_CODE: `Comment avez-vous connu?`,
      SIGNING_UP: `Comment avez-vous connu?`,
      SIGNING_UP_DESCR: `Bénéficier d'un essai gratuit de 30 jours sans CB`,
      SIGNING_UP_DESCR_BENEFIT: `Veuillez entrer les champs suivants pour recevoir votre invitation à Sound Care:`,
      SIGNING_NO_PRESCRIBER_CODE: `Veuillez enter votre adresse email pour recevoir votre invitation à Sound Care:`,
      TRY_TODAY: `À partir d’aujourd’hui.`,
      WELCOME_TO_MUSIC_CARE: `Bienvenue sur Sound Care`,
      SIGNUP_BUTTON_1: `J'ai un code partenaire`,
      SIGNUP_BUTTON_2: `Par un établissement de santé`,
      SIGNUP_BUTTON_3: `Par un médecin généraliste`,
      SIGNUP_BUTTON_4: `Autres professionnels de santé`,
      OR: `OU`,
    },
    settings: {
      BACK: `Retour`,
      INVITE_PATIENT: `Recommander à un patient`,
      SETTINGS: `Paramètres du compte`,
      ALARM: `Régler votre réveil`,
      DOWNLOADING_IN_BACKGROUND: `En cours`,
      DOWNLOAD_BACKGROUND: `Télécharger en arrière-plan`,
      MY_PLAYLIST: `Ma playlist`,
      COULD_NOT_REMOVE_FILE: `Impossible de supprimer le fichier fichier`,
      UNABLE_TO_DOWNLOAD_AT_THIS_TIME: `Impossible de télécharger pour le moment`,
      NOT_CONNECTED_TO_THE_INTERNET: `Vous n'êtes pas connecté à Internet`,
      DOWNLOADING: `Téléchargement`,
      SELECT_ALL: `Tout sélectionner`,
      DESELECT_ALL: `Tout déselectionner`,
      START_DOWNLOAD: `Commencer`,
      DOWNLOAD_MUSIC_DESC: `Cliquez sur une séance pour le téléchargement et y accéder hors ligne.`,
      YES: 'Oui',
      NO: 'Non',
      CHANGE_LANGUAGE: `Langue`,
      YOUR_HISTORY: `Historique`,
      DOWNLOAD_MUSIC: `Téléchargement`,
      ABOUT_MUSIC_CARE: `Traitement`,
      TERMS: `CGU & Mentions légales`,
      PRIVACY: `Politique`,
      JOIN_DATE: 'Membre depuis: ',
      ACCOUNT: `Contacter le support`,
      VIEW_ACCOUNT: 'Mon Compte',
      CHANGE_PASSWORD: 'Réinitialiser un mot de passe',
      CHANGE_CARD: 'Changer mode de paiement',
      PAYMENT_HISTORY: `Historique de  paiement`,
      LOG_OUT: `Déconnexion`,
      OLD_PASS: 'Ancien Mot de Passe',
      NEW_PASS: 'Nouveau mot de passe',
      SAVE_MUSIC_FILES_TO_DEVICE: `Téléchargement`,
      CANCEL_SUBSCRIPTION_TITLE: `Désabonnement (Effectif a la fin du mois déjà payé)`,
      REACTIVATE_SUBSCRIPTION_TITLE: `Réabonnement du compte`,
      CANCEL_SUBSCRIPTION: `Se désabonner`,
      REACTIVATE_SUBSCRIPTION: `Se réabonner`,
      // Do not translate the two language strings below:
      EN: `English`,
      FR: `Français`,
      UPDATE_INFO: `We are updating application...`,
      UPDATE_DEVICE: `Please don't turn off your device!`,
      TRAINING_VIDEO: `Formation Flash`,
    },
    treatment: {
      ANXIETY: `Stress`,
      AWAKENING: `Réveil`,
      PAIN: `Bien-être`,
      PLEASE_CHOOSE_A_TREATMENT: `Choisissez votre objectif`,
      SLEEPING: `Sommeil`,
      TREATMENT_DESCR: `Après avoir sélectionné votre objectif, un algorithme musical sera appliqué.`,
    },
    treatmentSlides: {
      slide1: {
        TITLE: 'Bien dormir',
        SUBTITLE: 'Choisir la Séquence en L',
      },
      slide2: {
        TITLE: 'Bien-être et Stress',
        SUBTITLE: 'Choisir la Séquence en U',
      },
      slide3: {
        TITLE: 'Bien se réveiller',
        SUBTITLE: 'Choisir la Séquence en J',
      },
    },
    indication: {
      ANXIETY: `Bien-être et Stress`,
      AWAKENING: `Bien se réveiller`,
      PAIN: `Bien-être et Stress`,
      SLEEP: `Bien dormir`,
    },
    playlist: {
      YOU_DID_NOT_SELECT: `Vous n'avez encore sélectionné aucune chanson`,
      MY_PLAYLIST_DESCR: `Créez une liste personnalisée en sélectionnant des chansons dans l'onglet de gauche.`,
      CREATE_MY_PLAYLIST: `Créer ma playlist`,
      MY_PLAYLIST: `Ma playlist`,
      PLAYING_LAST_PLAYLIST_SONG: `Lecture en cours de la dernière chanson de la playlist`,
      NEXT_SONG: `Prochaine séance`,
      APPROXIMATELY_TIME_LEFT: `Il reste environ {{ timeLeft }} minutes dans la playlist`,
    },
    video: {
      ANTARCTIC: `Antarctique`,
      BOTSWANA: `Botswana`,
      BRASIL: `Brésil`,
      CARAIBES: `Caraïbes`,
      'DESERT-DU-MAROC': `Désert du Maroc`,
      INDONESIE: `Indonesie`,
      MALI: `Mali`,
      'MED-CELTIQUE': `Méd celtique`,
      MONGOLE: `Mongole`,
    },
    welcome: {
      DAYS_LEFT: `Jours restants`,
      PRESCRIBE_MUSIC_CARE: `Recommander à un patient`,
      PREVIEW_MUSIC: 'Extraits musicaux de 30 secundes',
      MAKE_DEMONSTRATION: `Faire une démonstration`,
      USE_PERSONAL: `Utiliser à titre personnel`,
      NEW_SUBSCRIPTION: `Utiliser Sound Care Pro`,
      WELCOME: `Bienvenu à Sound Care`,
      WELCOME_DOCTOR_TITLE: `Choisissez votre mode`,
      WATCH_VIDEO: `Présentation vidéo`,
      REGISTER_FOR: `Utiliser Sound Care Pro`,
      SKIP_VIDEO: `Passer l'intro`,
      HOW_TO_USE: `Comment utiliser Sound Care ?`,
      CHOOSE_ENVIRONMENT: `Choisir un environnement calme, propice à la relaxation`,
      USE_EARPHONES: `Utiliser un casque ou une paire d'enceintes de bonne qualité`,
      UNLIMITED_ACCESS: `En savoir plus`,
      LIE_DOWN: `S'installer confortablement et se laisser guider par la musique`,
    },
    subscription: {
      SUBSCRIBE: `S'abonner`,
      CONTINUE: `Continuer`,
      PRICE: `29.90`,
      CURRENCY: `EUR`,
      INFO_LINE_1: `Accès illimité aux soins Sound Care`,
      INFO_LINE_2: `Prescrire Sound Care à vos patients`,
      INFO_LINE_3: `Accédez aux rapports des niveaux de Bien-être et de stress (avant et après le soin Sound Care) de vos patients`,
      INFO_LINE_4: `Accès aux capsules formation pro`,
      INFO_LINE_5: `Assistance 24h/24`,
      INFO_LINE_6: `Redevance SACEM comprise`,
      INFO_LINE_7: `Une licence professionnelle incluse`,
      FAST_RELIEF: `Sound Care, le soin par la musique, vous permettra de:`,
      PER_MONTH: `par mois`,
      MANAGE_ACCOUNT: `Besoin de gérer votre compte?`,
      MANAGE_SUBSCRIPTION: `L'essai gratuit ou l'abonnement a expiré`,
      MANAGE_PAYMENT: `Mettez à jour votre mode de paiement`,
      MANAGE_GO_TO: `Veuillez accéder à Sound Care sur le Web pour gérer votre compte.`,
      AUTOMATIC_RENEWAL_DESCR: `L’abonnement mensuel est facturé et renouvelé automatiquement chaque mois. Il est possible d’annuler sans frais. Eligible uniquement pour les nouveaux utilisateurs.`,
      FACTURATION_DESCR: `Un montant de {{ usd }}{{ price }}{{ eur }} vous sera automatiquement facturé chaque mois jusqu’à ce que vous annulez. Vous pourrez vous désabonner à tout moment à partir de votre compte sur Sound Care.`,
      PAYMENT_INFO: `Informations de Paiement`,
      CANCEL_ANYTIME: `Annuler à tout moment`,
      BEGINNING_TODAY: `À partir d'aujord'hui`,
      INSCRIPTION: `Votre essai est terminé`,
      DESCRIPTION_1: `Aidez-nous à améliorer Sound Care en répondant aux questions suivantes:`,
      QUESTION_1: `Sound Care a-t-il contribué à soulager votre Bien-être, anxiété et/ou troubles du sommeil?`,
      QUESTION_2: `Avez-vous trouvé Sound Care facile à utiliser?`,
      QUESTION_3: `Recommanderiez-vous le soin Sound Care?`,
    },
    registrationPage: {
      ACCOUNT_CREATED_SUCCESSFULLY: `Compte enregistré avec succès`,
      CONGRATULATIONS: `Accédez dès maintenant à l’application Sound Care pour la recommander à vos patients`,
      CONGRATULATIONS_SUBTITLE: `Accédez dès maintenant à l’application Sound Care pour la recommander à vos patients.`,
      DOCTOR_ID: `Numéro RPPS ou ADELI`,
      DOCTOR_ID_CAN_BE_AT_MOST: `Le numéro RPPS/ADELI peut comporter au maximum {{max}} caractères`,
      DOCTOR_ID_IS_REQUIRED: `Le numéro RPPS est requis`,
      DOCTOR_REGISTRATION: `Inscription`,
      EMAIL: `Email`,
      LEGAL_DOCTOR_A: `J’ai lu et accepte expressément les `,
      LEGAL_DOCTOR_B: ` de Sound Care.`,
      LEGAL_DOCTOR_DESCR_A: `Vos données personnelles ici collectées sont utilisées conformément à la `,
      LEGAL_DOCTOR_DESCR_B: ` (Article B§3) de Sound Care aux fins de répondre à ses obligations précontractuelles et/ou contractuelles à votre égard dans le cadre la fourniture des services de Sound Care liés à votre Compte. Pour toute question relative à vos données personnelles, vous pouvez contacter son délégué à la protection des données (ci-après « DPO ») joignable à l’adresse postale Sound Care – DPO 7 rue Popincourt – 75011 Paris (France) ou par email : dpo@music.care`,
      LEGAL_DOCTOR_DESCR_LINK: `Politique de Protection des Données`,
      LEGAL_DOCTOR_LINK: `Conditions Générales d’Utilisation des Services`,
      LEGAL_DOCTOR_C_1: `J’accepte que mes Données de Santé soient utilisées par Sound Care suivant sa Politique de `,
      LEGAL_DOCTOR_C_2: ` de façon totalement anonymisée pour des recherches scientifiques pour le développement des services thérapeutiques de Sound Care. Je peux m’opposer à cet usage à tout moment en cliquant `,
      LEGAL_DOCTOR_C_3: ` ou sur demande écrite aux coordonnées précitées.`,
      LEGAL_DOCTOR_LINK_2: `Protection des Données`,
      LEGAL_DOCTOR_LINK_3: `ICI`,
      NAME: `Nom complet`,
      NAME_CAN_BE_AT_MOST: `Le nom peut comporter au maximum {{max}} caractères`,
      NAME_IS_REQUIRED: `Le nom est requis`,
      PASSWORD: `Mot de passe`,
      PASSWORD_CONFIRM: `Confirmez le mot de passe`,
      PASSWORD_CAN_BE_AT_MOST: `Le mot de passe peut comporter au maximum {{max}} caractères`,
      PASSWORDS_DO_NOT_MATCH: `Les mots de passe ne correspondent pas`,
      PASSWORD_IS_REQUIRED: `Le mot de passe est requis`,
      PASSWORD_IS_TOO_SHORT: `Le mot de passe est trop court`,
      PASSWORD_MUST_CONTAIN: `Le mot de passe doit contenir au moins un chiffre, une majuscule, une minuscule et un caractère spécial.`,
      REGISTER: `Terminer l’inscription`,
      RPPS_INVALID: `RPPS/ADELI non valide`,
      TOGGLE_PASSWORD_VISIBILITY: `Basculer la visibilité du mot de passe`,
      JOIN_TERMS_UNCHECKED: `Veuillez accepter les condition de ventes et notre politique de donnes pour completer votre inscription`,
      INVALID_INVITE: `Invitation invalide ou expirée`,
      INVITATION_INVALIDE_OU_EXPIRE: `Invitation invalide ou expirée`,
      PLEASE_COMPLETE_E_LEARNING_MODULE: `Veuillez compléter le module e-learning avant de vous inscrire`,
    },
    notification: {
      TITLE: `Sound Care`,
      DESCRIPTION: `Listening music...`,
      DESCRIPTION_UPDATE: `Updating the application...`,
    },
    license: {
      SCREEN_LIMIT: `Limite d'écran`,
      DESCRIPTION_1: `Trop de personnes utilisent votre compte en ce moment.`,
      DESCRIPTION_2: `Veuillez vous déconnecter d'un ou de plusieurs appareils et réessayer.`,
      DESCRIPTION_3: `Vous pouvez également demander à vous déconnecter de tous vos appareils `,
      DESCRIPTION_LINK: `ici.`,
      MORE_LICENSES: `Demander plus de licences`,
      MORE_LICENSES_EMAIL: `https://app.music.care/contact`,
      CONTACT: `Contact support`,
      CONTACT_EMAIL: `https://app.music.care/contact`,
      GO_BACK: `Retourner`,
    },
    requestAccess: {
      MAIN_INSCRIPTION: `Bienvenue`,
      MAIN_DESCRIPTION: `La première thérapie digitale validée par plus de 150 publications scientifiques dans le traitement de la Bien-être, de l'anxiété et des troubles du sommeil.`,
      INSCRIPTION: `Obtenir un code`,
      HEADER: `Demande reçue`,
      DESCRIPTION_1: `Afin de bénéficier du soin Sound Care, merci de bien vouloir répondre aux 3 questions suivantes?`,
      DESCRIPTION_2: `Un membre de l’équipe de Sound Care prendra contact avec vous rapidement.`,
      DESCRIPTION_3: `Veuillez prévoir jusqu’à 48 heures pour la confirmation de votre accès.`,
      SIGNUP: `Obtenir un accès`,
      REQUEST_ACCESS: `Obtenir un code partenaire`,
      MEMBER: `Déjà membre? Connectez-vous`,
      GO_BACK: `Retour`,
      EMAIL: `Adresse e-mail`,
      QUESTION_1: `Vous présentez des Bien-êtres?`,
      QUESTION_2: `Vous ressentez du stress?`,
      QUESTION_3: `Vous avez des troubles du sommeil?`,
      TRUE: `Oui`,
      FALSE: `Non`,
    },
  },
}
